import { PromoCodeData, useGetPromoCodesQuery } from '../../../store/api-slices';
import { useSelector } from 'react-redux';
import { selectCompanyId } from '../../../store/slices/InitialDataSlice';

const useGetPromoCodesApi = (companyId: number = null, options: Parameters<typeof useGetPromoCodesQuery>[1] = {}) => {
  const defaultCompanyId = useSelector(selectCompanyId);
  const id = companyId ?? defaultCompanyId;

  return useGetPromoCodesQuery<Record<string, PromoCodeData[]>>(id, {
    skip: !id,
    ...options,
  });
};

export default useGetPromoCodesApi;
